import React from 'react';
import jQuery from 'jquery';
import 'select2/dist/css/select2.min.css';
import 'select2/dist/js/select2.min.js';
import '../../css/base.css';
import FilterVM from '../FilterVM/FilterVM';
import FilterModels from '../FilterModels/FilterModels';
import FilterChassis from '../FilterChassis/FilterChassis';
import FilterSpareParts from '../FilterSpareParts/FilterSpareParts';
import FilterTavole from '../FilterTavole/FilterTavole';
import BaseClass from '../common/baseClass';
import '../../css/page-body.css';
import '../../css/print.css';

import { connect } from "react-redux";
import { changeFilter, changeDatalist, changeMutex, changeValues} from "../../redux/actions";
import { pageB2CSelector } from "../../redux/selectors";

const common = require('../common/common');
window.jQuery = jQuery;

try {
  require ('select2/dist/js/i18n/'+ common.getLanguage() +'.js');
} catch (err) {
  require ('select2/dist/js/i18n/en.js');
}

class PageB2C extends BaseClass {
  constructor(props){
    super(props);
    this.state.marcheVM = [];
  }

  async componentWillMount(props){
    this.updateStateWithStoreProps();

    document.getElementById('body').className='content_page';
    // carico tutte le marche disponibili
    var marcheVM = await common.getAppEnabledVM();
    this.setState({marcheVM: marcheVM});
  }

  componentWillReceiveProps(nextProps){
    this.updateStateWithStoreProps(nextProps);
  }

  componentDidUpdate() {
    this.updateStateWithStoreProps();
  }


  shouldComponentUpdate(nextProps, nextState){
    return super.shouldComponentUpdate(nextProps, nextState)
  }

  render(props){
    return(
      <div className="row mt-5 noStampa">

        {this.state.marcheVM ?
          <>
          {
          this.state.marcheVM.length > 1 ?
            <FilterVM></FilterVM>
          :
            ""
          }
          <div id="filtri_files" className="row justify-content-between" style={{width: "100%"}}>
            <FilterChassis></FilterChassis>
            <FilterSpareParts></FilterSpareParts>
            <FilterModels></FilterModels>
            <FilterTavole></FilterTavole>
          </div>
          </>
        :
          <></>
        }
      </div>
    )
  }
}

const mapStateToProps = state => {
  const store = pageB2CSelector(state);
  return { store };
}
export default connect(mapStateToProps, {changeFilter, changeDatalist, changeMutex, changeValues})(PageB2C);
//export default PageB2C;
